// ─────────────────────────────────────────────────────────────────────────
// Social icon set — Ecoffee Cup® SA.
// Drawn on a 24px grid with a 1.5px round stroke so they sit alongside the
// Lucide icons used across the site. Each icon is stored as raw SVG inner
// markup so the same source renders on the site AND exports as a clean,
// standalone SVG for Figma.
// Handles are placeholders — confirm with the client before launch.
// ─────────────────────────────────────────────────────────────────────────

export type SocialIcon = {
  id: string
  name: string
  handle: string
  href: string
  /** Inner SVG markup, drawn for a 24 × 24 viewBox, stroke = currentColor */
  paths: string
}

export const socialIcons: SocialIcon[] = [
  {
    id: 'instagram',
    name: 'Instagram',
    handle: '@ecoffeecupsa',
    href: 'https://instagram.com/',
    paths:
      '<rect x="3" y="3" width="18" height="18" rx="5"/><circle cx="12" cy="12" r="4"/><circle cx="17.5" cy="6.5" r="0.6" fill="currentColor" stroke="none"/>',
  },
  {
    id: 'facebook',
    name: 'Facebook',
    handle: 'Ecoffee Cup South Africa',
    href: 'https://facebook.com/',
    paths:
      '<path d="M15.5 3H13a4 4 0 0 0-4 4v3H6.5v3.5H9V21h3.5v-7.5H15l.5-3.5h-3V7.5a1 1 0 0 1 1-1h2Z"/>',
  },
  {
    id: 'tiktok',
    name: 'TikTok',
    handle: '@ecoffeecupsa',
    href: 'https://tiktok.com/',
    paths:
      '<path d="M14 3v11.5a3.5 3.5 0 1 1-3.5-3.5"/><path d="M14 3c.4 2.6 2.4 4.6 5 5"/>',
  },
  {
    id: 'pinterest',
    name: 'Pinterest',
    handle: 'ecoffeecupsa',
    href: 'https://pinterest.com/',
    paths:
      '<circle cx="12" cy="12" r="9"/><path d="M11 21l1.6-7.2"/><path d="M9.3 14.2A3.6 3.6 0 1 1 13 15.6c-.9.1-1.5-.3-1.5-.3"/>',
  },
  {
    id: 'youtube',
    name: 'YouTube',
    handle: 'Ecoffee Cup SA',
    href: 'https://youtube.com/',
    paths:
      '<rect x="2.5" y="5" width="19" height="14" rx="4"/><path d="M10.25 9.25v5.5L15 12Z"/>',
  },
  {
    id: 'linkedin',
    name: 'LinkedIn',
    handle: 'Ecoffee Cup South Africa',
    href: 'https://linkedin.com/',
    paths:
      '<rect x="3" y="3" width="18" height="18" rx="4"/><path d="M8 10.5V17"/><circle cx="8" cy="7.5" r="0.6" fill="currentColor" stroke="none"/><path d="M12 17v-6.5"/><path d="M12 13.5a2.75 2.75 0 0 1 5.5 0V17"/>',
  },
  {
    id: 'whatsapp',
    name: 'WhatsApp',
    handle: '+27 (0)00 000 0000',
    href: 'https://wa.me/',
    paths:
      '<path d="M3.5 20.5l1.3-4.1A8.5 8.5 0 1 1 7.9 19.4Z"/><path d="M9 8.6c.1 3.4 3 6.3 6.4 6.4l1-1.4-2-1-1 .7a4.4 4.4 0 0 1-2.2-2.2l.7-1-1-2Z"/>',
  },
]

/** The channels shown in the site footer. */
export const footerSocials = ['instagram', 'facebook', 'tiktok', 'pinterest']

/** Builds a standalone SVG file for download or copy-to-Figma. */
export function toSvgString(icon: SocialIcon, colour = '#3B302F', size = 24) {
  return `<svg xmlns="http://www.w3.org/2000/svg" width="${size}" height="${size}" viewBox="0 0 24 24" fill="none" stroke="${colour}" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" style="color:${colour}">${icon.paths.replace(
    /currentColor/g,
    colour,
  )}</svg>`
}
